import { Box, Stack } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useRecoilValue } from "recoil";
import { authState } from "../recoil/authState";
import { useTheme } from "@emotion/react";
import { NAV } from "./config-layout";
import Scrollbar from "../component/scrollbar/scrollbar";
import { usePathname } from "../routes/hooks";
import { useNavData, useBottomNavData } from "./navData";
import NavLogo from "./nav/NavLogo";
import RecursiveNav from "./nav/RecursiveNav";
import { useNavExpanded } from "./nav/useNavExpanded";

export default function Nav() {
  const pathname = usePathname();
  const navigate = useNavigate();
  const auth = useRecoilValue(authState);
  const isMasterAuth = auth.user.club_admin_level === 10;
  const theme = useTheme();
  const navData = useNavData();
  const bottomNavData = useBottomNavData();
  const { expandedKeys, handleToggleExpand } = useNavExpanded(pathname);

  return (
    <Box
      sx={{
        width: NAV.WIDTH,
        "*": { color: "#FAF9F6" },
      }}
    >
      <Box
        width={280}
        height="100%"
        position="fixed"
        sx={{
          position: "fixed",
          backgroundColor: "#004B49",
        }}
      >
        <Scrollbar
          sx={{
            height: 1,
            "& .simplebar-content": {
              height: "100%",
              display: "flex",
              flexDirection: "column",
              backgroundColor: "#004B49",
            },
          }}
        >
          <NavLogo />
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "20px",
              height: "100%",
            }}
          >
            <Stack component="nav" spacing={0.5} sx={{ px: 2, flex: 1 }}>
              <RecursiveNav
                items={navData}
                pathname={pathname}
                theme={theme}
                isMasterAuth={isMasterAuth}
                expandedKeys={expandedKeys}
                onToggleExpand={handleToggleExpand}
                navigate={navigate}
              />
            </Stack>

            {/* Bottom Navigation Section */}
            <Stack 
              component="nav" 
              spacing={0.5}
              sx={{ 
                px: 2, 
                pb: 2,
                bgcolor: "#004B49",
                "& .MuiBox-root": {
                  marginLeft: 0,
                },
              }}
            >
              <RecursiveNav
                hideParent={true}
                items={bottomNavData}
                pathname={pathname}
                theme={theme}
                isMasterAuth={isMasterAuth}
                expandedKeys={expandedKeys}
                onToggleExpand={handleToggleExpand}
                isChild={false}
                navigate={navigate}
              />
            </Stack>
          </Box>
        </Scrollbar>
      </Box>
    </Box>
  );
}
